// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__12fhe","numberCell":"Table_numberCell__13S6c","detailsBtn":"Table_detailsBtn__1z1mP"};